<template>
  <div v-if="typeof value === 'string'" ref="EditorWrapper">
    <editor-content :editor />
  </div>
  <template v-else-if="typeof value === 'number'">
    {{ value }}
  </template>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useTipTapEditor } from '@/composables/tiptap';
import { EditorContent } from '@tiptap/vue-3';

const props = defineProps<{
  value?: string | number | boolean;
  disableLineBreaks?: boolean;
  disableLinks?: boolean;
  allowRightAlignment?: boolean;
}>();

const { editor } =
  typeof props.value === 'string'
    ? useTipTapEditor(
        props.value,
        {
          disableLineBreaks: props.disableLineBreaks,
          disableLinks: props.disableLinks,
          allowRightAlignment: props.allowRightAlignment,
        },
        {
          editable: false,
          onDestroy() {
            if (!EditorWrapper.value) {
              return;
            }
            const content = EditorWrapper.value.innerHTML;
            EditorWrapper.value.innerHTML = content;
          },
        },
      )
    : { editor: undefined };

watch(
  () => props.value,
  () => {
    editor?.value?.commands.setContent(props.value?.toString() ?? '');
  },
);
const EditorWrapper = ref<HTMLDivElement>();
</script>
